export default {"src":"/evde-internet/_next/static/media/gift.6640eab3.svg","height":52,"width":60};